import {
  ActualUseEnum,
  BasementConversionEnum,
  BasementEnum,
  BuildingStandardDeterminationMethodEnum,
  HouseOrApartmentTypeEnum,
  ModernizationMethodEnum,
  ObjectTypeEnum,
  OutdoorFacilitiesEnum,
  OwnershipEnum,
  ProductTypeEnum,
  PropertyInformation,
  RentReferenceEnum,
  RoofEnum,
  getDefaultBuildingData,
} from "@/types/refineRealEstate";

export const initialState: PropertyInformation = {
  generalInfo: {
    productType: ProductTypeEnum.marketValue,
    objectType: ObjectTypeEnum.house,
    buildingType: undefined,
    ownership: OwnershipEnum.fullOwnership,
    selfUseSuitability: true,
    actualUse: ActualUseEnum.ownerOccupied,
    completionStatus: "completedFull",
  },
  plotData: {
    plotArea: undefined,
    completionStatus: "notStarted",
  },
  buildingData: {
    constructionYear: undefined,
    livingArea: undefined,
    garages: undefined,
    completionStatus: "notStarted",
  },
  energyAndPhotovoltaic: {
    energyCertificate: undefined,
    energyEfficiencyHouseStandard: undefined,
    issueDate: undefined,
    certificateType: undefined,
    finalEnergy: undefined,
    primaryEnergy: undefined,
    CO2Emissions: undefined,
    photovoltaicAvailable: false,
    constructionYear: undefined,
    annualPowerYield: undefined,
    completionStatus: "notStarted",
  },
  buildingStandard: {
    method: BuildingStandardDeterminationMethodEnum.automatic,
    completionStatus: "completedFull",
  },
  modernization: {
    method: ModernizationMethodEnum.automatic,
    completionStatus: "completedFull",
  },
  propertyImages: {
    completionStatus: "notStarted",
  },
  financialAndRentalInfo: {
    completionStatus: "notStarted",
  },
};

export const initialStateHouse: PropertyInformation = {
  ...initialState,
  buildingData: {
    ...initialState.buildingData,
    ...getDefaultBuildingData(ObjectTypeEnum.house),
    roof: RoofEnum.full,
    basement: BasementEnum.full,
    basementConversion: BasementConversionEnum.none,
    houseOrApartmentType: HouseOrApartmentTypeEnum.detachedHouse,
    outdoorFacilities: OutdoorFacilitiesEnum.average,
  },
};

export const initialStateApartment: PropertyInformation = {
  ...initialState,
  generalInfo: {
    ...initialState.generalInfo,
    ownership: OwnershipEnum.apartmentOwnership,
  },
  buildingData: {
    ...initialState.buildingData,
    outdoorParkingSpaces: undefined,
    floorNumber: 0,
    ...getDefaultBuildingData(ObjectTypeEnum.apartment),
    garden: false,
    elevator: false,
  },
};

export const initialStateMultifamilyHouse: PropertyInformation = {
  ...initialState,
  buildingData: {
    ...initialState.buildingData,
    ...getDefaultBuildingData(ObjectTypeEnum.multiFamilyHouse),
    roof: RoofEnum.full,
    basement: BasementEnum.full,
    basementConversion: BasementConversionEnum.none,
    outdoorParkingSpaces: undefined,
    elevator: false,
  },
  financialAndRentalInfo: {
    ...initialState.financialAndRentalInfo,
    rent: {
      reference: RentReferenceEnum.euroPerSquareMeter,
    },
  },
};

export const initialStateByObjectType = (objectType: ObjectTypeEnum): PropertyInformation => {
  switch (objectType) {
    case ObjectTypeEnum.multiFamilyHouse:
    case ObjectTypeEnum.mixedUseProperty:
      return initialStateMultifamilyHouse;
    case ObjectTypeEnum.apartment:
      return initialStateApartment;
    case ObjectTypeEnum.house:
      return initialStateHouse;
    default:
      return initialState;
  }
};
